import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

let connection = null;

export async function getSignalRConnection(url) {
  if (!connection) {
    connection = new HubConnectionBuilder()
      .withUrl(url)
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect() // Reconexión automática
      .build();

    // Manejo de cierre de la conexión (cuando se pierde)
    connection.onclose(async (error) => {
      console.error('Conexión cerrada, intentando reconectar...', error);
      await attemptReconnect();
    });
  }

  // Verificar si la conexión no está en un estado transitorio
  if (connection.state === HubConnectionState.Disconnected) {
    try {
      await connection.start();
    } catch (error) {
      console.error('Error al intentar iniciar la conexión:', error);
    }
  }

  return connection;
}

// Intentar reconectar manualmente si la conexión se pierde
async function attemptReconnect() {
  if (connection.state === HubConnectionState.Disconnected) {
    try {
      await connection.start();
    } catch (error) {
      console.error('Error al reconectar a SignalR:', error);
      // Reintentar en 5 segundos si la reconexión falla
      setTimeout(attemptReconnect, 5000);
    }
  }
}
